// extracted by mini-css-extract-plugin
export var dividerContainer = "_7d-0";
export var line = "_7d-1";